import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link } from 'react-router-dom';
import vAdminformat from '../../adminFormat';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function UpdateCompay({ username, onCompanyID, onClose, getCompany }) {
    const [loading, setLoading] = useState(false);
    const [userCreated, setUserCreated] = useState("");
    const [userModify, setUserModify] = useState("");
    const [dateCreated, setDateCreated] = useState("");
    const [dateModify, setDateModify] = useState("");
    const [formData, setFormData] = useState({
        id: '',
        name: '',
        phone: '',
        phone2: '',
        website: '',
        email: '',
        title1: '',
        title2: '',
        title3: '',
        address: '',
        city: '',
        zipcode: '',
        country: '',
        comment: '',
        user_transaction: username,
        est_id: ''
    });

    useEffect(() => {
        const fetchCompayData = async () => {
            try {
                const response = await axios.get(`${server_backend}/company/select?id=${onCompanyID}`, headers);
                //console.log(response.data)
                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT[0];
                    setUserCreated(data.user_created);
                    setUserModify(data.user_modify);
                    setDateCreated(data.date_created);
                    setDateModify(data.date_modify);
                    setFormData({
                        id: onCompanyID,
                        name: data.name,
                        phone: data.phone,
                        phone2: data.phone2,
                        website: data.website,
                        email: data.email,
                        title1: data.title1,
                        title2: data.title2,
                        title3: data.title3,
                        address: data.address,
                        city: data.city,
                        zipcode: data.zipcode,
                        country: data.country,
                        comment: data.comment,
                        user_transaction: username,
                        est_id: data.est_ID
                    });
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchCompayData();
    }, [onCompanyID, username]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/company/update`, formData, headers);
                    setLoading(true);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Updated Successfully',
                            showConfirmButton: false,
                            timer: 1000
                        });
                        onClose();
                        getCompany();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'There is already a Compay with the same name, please try with another name',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    return (

        <div className="card">
            <div className="card-header align-items-center d-flex">
                <div className="col-md-12">
                    <div className="text-end">
                        <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Alert',
                                text: "Are you sure you want to discard these changes?",
                                showCancelButton: true,
                                confirmButtonText: 'Accept',
                                cancelButtonText: "Cancel"
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    onClose();
                                }
                            }
                            )
                        }
                        }>Discard Change</Link>
                        <Link to="#" onClick={handleUpdate} className="btn btn-primary">
                            {loading ? "Loading..." : "Update"}
                        </Link>
                    </div>
                </div>
            </div>
            <div className="col-12 card-body">
                <form onSubmit={handleUpdate}>
                    <div className="row">
                        <div className="col-12">
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter company name"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label htmlFor="phone" className="form-label">Phone</label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    placeholder="Enter phone number"
                                    id="phone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label htmlFor="phone2" className="form-label">Phone 2</label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    placeholder="Enter second phone number"
                                    id="phone2"
                                    name="phone2"
                                    value={formData.phone2}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter email address"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label htmlFor="website" className="form-label">Website</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter website URL"
                                    id="website"
                                    name="website"
                                    value={formData.website}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <h4 className='p-4'>Address</h4>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label htmlFor="address" className="form-label">Address</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter address"
                                    id="address"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label htmlFor="city" className="form-label">City</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter your city"
                                    id="city"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label htmlFor="zipcode" className="form-label">Post Code</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter your Post Code"
                                    id="zipcode"
                                    name="zipcode"
                                    value={formData.zipcode}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label htmlFor="country" className="form-label">Country</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter your country"
                                    id="country"
                                    name="country"
                                    value={formData.country}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <h4 className='p-4'>Additional Information</h4>
                        <div className="col-md-4">
                            <div className="mb-3">
                                <label htmlFor="title1" className="form-label">Title 1</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter title 1"
                                    id="title1"
                                    name="title1"
                                    value={formData.title1}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="mb-3">
                                <label htmlFor="title2" className="form-label">Title 2</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter title 2"
                                    id="title2"
                                    name="title2"
                                    value={formData.title2}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="mb-3">
                                <label htmlFor="title3" className="form-label">Title 3</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter title 3"
                                    id="title3"
                                    name="title3"
                                    value={formData.title3}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="mb-3">
                                <label htmlFor="comment" className="form-label">Comment</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter comment"
                                    id="comment"
                                    name="comment"
                                    value={formData.comment}
                                    onChange={handleChange}
                                ></textarea>
                            </div>
                        </div>


                        <h4 className='p-4'>Other Information</h4>
                        <div className="col-6">
                            <div className="mb-3">
                                <label htmlFor="user_transaction" className="form-label">Date Created</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="user_transaction"
                                    value={vAdminformat.FormatDate(dateCreated)}
                                    name="user_transaction"
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label htmlFor="user_transaction" className="form-label">User Created</label>
                                <input
                                    type="text"
                                    className="form-control"

                                    id="user_transaction"
                                    value={userCreated}
                                    name="user_transaction"
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label htmlFor="user_transaction" className="form-label">Date Modified</label>
                                <input
                                    type="text"
                                    className="form-control"

                                    id="user_transaction"
                                    value={dateModify && vAdminformat.FormatDate(dateModify)}
                                    name="user_transaction"
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label htmlFor="user_transaction" className="form-label">User Modified</label>
                                <input
                                    type="text"
                                    className="form-control"

                                    id="user_transaction"
                                    value={userModify}
                                    name="user_transaction"
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="text-end">

                            </div>
                        </div>
                        <div className="card-header align-items-center d-flex">
                            <div className="col-md-12">
                                <div className="text-end">
                                    <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                        Swal.fire({
                                            icon: 'warning',
                                            title: 'Alert',
                                            text: "Are you sure you want to discard these changes?",
                                            showCancelButton: true,
                                            confirmButtonText: 'Accept',
                                            cancelButtonText: "Cancel"
                                        }).then(async (result) => {
                                            if (result.isConfirmed) {
                                                onClose();
                                            }
                                        }
                                        )
                                    }
                                    }>Discard Change</Link>
                                    <button type="submit" className="btn btn-primary" disabled={loading}>
                                        {loading ? 'Loading...' : 'Update'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default UpdateCompay;
